import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class EmailValidationService {

  constructor(private accountService: AccountService) {}

  validateEmail(email: string): Observable<{
    isValid: boolean;
    error?: string;
    isDisposable?: boolean;
    isConnected?: boolean;
  }> {
    // Use the account service's validateEmail method
    return this.accountService.validateEmail(email);
  }
}
